export const WebSocketConnector = 'WebSocketConnector';
export const SyncRegistry = 'SyncRegistry';
export const PlatformSyncDetector = 'PlatformSyncDetector';
